import React, { ReactNode } from 'react';
import clsx from 'clsx';

import { UIFormPanel, UIFormPanelProps } from '@futrli/ui-components';
import styles from './ui-dual-list-panel.scss';

export interface UIDualListPanelProps extends UIFormPanelProps {
  list1?: ReactNode;
  list2?: ReactNode;
  search1?: ReactNode;
  search2?: ReactNode;
  title1?: ReactNode;
  title2?: ReactNode;
}

export const UIDualListPanel = ({
  className,
  list1,
  list2,
  search1,
  search2,
  title1,
  title2,
  ...props
}: UIDualListPanelProps) => {
  return (
    <UIFormPanel className={clsx(styles.container, className)} {...props}>
      <div className={styles.search1}>{search1}</div>
      <div className={clsx(styles.leftListContainer, styles.list1)}>
        {title1 && <strong className={styles.title}>{title1}</strong>}
        <div className={styles.listContent}>{list1}</div>
      </div>

      <div className={styles.search2}>{search2}</div>
      <div className={clsx(styles.rightListContainer, styles.list2)}>
        {title2 && <strong className={styles.title}>{title2}</strong>}
        <div className={styles.listContent}>{list2}</div>
      </div>
    </UIFormPanel>
  );
};
